module.exports = __webpack_public_path__ + "img/index-manual-step-5@3x.1a022069.png";